import React from 'react';
import { CircularProgress } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DetailsCard, { DetailsCardHandles } from '../Cards/DetailsCard';


type LinkedEntityGroup = {
  type: string;
  count: number;
};

type RelationshipDetailsPanelProps = {
  supplier: any;
  detailsCardRef: React.RefObject<DetailsCardHandles>;
  isEditingDetails: boolean;
  isSavingDetails: boolean;
  onDetailsCancel: () => void;
  onDetailsSave: () => void;
  onEditStateChange: (isEditing: boolean) => void;
  onSavingChange: (isSaving: boolean) => void;
  linkedEntityCount: number;
  linkedEntityGroups: LinkedEntityGroup[];
  formatRelationshipTypeLabel: (value?: string) => string;
  onGoToScreeningResults: () => void;
};

const RelationshipDetailsPanel: React.FC<RelationshipDetailsPanelProps> = ({
  supplier,
  detailsCardRef,
  isEditingDetails,
  isSavingDetails,
  onDetailsCancel,
  onDetailsSave,
  onEditStateChange,
  onSavingChange,
  onGoToScreeningResults,
}) => {
  return (
    <div className='relationship-explorer-right'>
      <div className='relationship-card relationship-details-card'>
        <div className='relationship-card-header'>
          <div className='relationship-card-title'>Entity Details</div>
          {!isEditingDetails && (
            <button
              type='button'
              className='relationship-card-action'
              onClick={() => detailsCardRef.current?.startEdit()}
            >
              <EditOutlinedIcon sx={{ fontSize: 16 }} />
              Edit Details
            </button>
          )}
        </div>
        {isEditingDetails && (
          <div className='relationship-details-actions'>
            <button
              type='button'
              className='create-new-team-btn relationship-details-action-btn'
              onClick={onDetailsCancel}
              disabled={isSavingDetails}
            >
              <div className='create-new-team-btn-text'>Cancel</div>
            </button>
            <button
              type='button'
              className='screening-btn relationship-details-action-btn'
              onClick={onDetailsSave}
              disabled={isSavingDetails}
            >
              {isSavingDetails ? (
                <>
                  <CircularProgress
                    size={16}
                    color='inherit'
                    style={{ marginRight: '8px' }}
                  />
                  <span style={{ display: 'inline-block' }}>Saving...</span>
                </>
              ) : (
                <span style={{ display: 'inline-block' }}>Save Changes</span>
              )}
            </button>
          </div>
        )}
        <DetailsCard
          ref={detailsCardRef}
          supplier={supplier}
          onEditStateChange={onEditStateChange}
          onSavingChange={onSavingChange}
          hideHeader
        />
        <div className='relationship-screening-results-cta'>
          <div className='relationship-screening-results-copy'>
            Jump to the latest screening summary, matches, and adverse findings
            for this entity.
          </div>
          <button
            type='button'
            className='screening-btn relationship-screening-results-btn'
            onClick={onGoToScreeningResults}
          >
            Go to Screening Results
          </button>
        </div>
      </div>

      {/* <div className='relationship-card relationship-linked-card'>
        <div className='relationship-card-header'>
          <div className='relationship-card-title'>
            Linked Entities ({linkedEntityCount})
          </div>
        </div>
        <div className='relationship-linked-chips'>
          {linkedEntityGroups.length === 0 ? (
            <div className='relationship-hierarchy-empty'>
              No linked entities yet.
            </div>
          ) : (
            linkedEntityGroups.map((group) => (
              <div key={group.type} className='relationship-linked-chip'>
                <span className='relationship-linked-dot'></span>
                <span>
                  {formatRelationshipTypeLabel(group.type)} ({group.count})
                </span>
              </div>
            ))
          )}
        </div>
      </div> */}
    </div>
  );
};

export default RelationshipDetailsPanel;
